import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const style = theme => ({
	root: {
		height: theme.components.transferList.row.height,
	}
})

function EmptyOptions({
	classes,
	children,
}) {
	return (
		<div className={classes.root}>
			{children}
		</div>
	)
}

EmptyOptions.propTypes = {
	classes: PropTypes.any,
	children: PropTypes.any,
}

EmptyOptions.defaultProps = {
}

export default withStyles(style)(EmptyOptions);